<template>
  <div
    :class="{
      'ps-opacity-25 ps-pointer-events-none': isStatusLoading
    }"
  >
    <div
      v-if="isStatusSuccess"
      class="border-8 border-white rounded-md bg-green-50 p-4"
    >
      <div class="flex">
        <div class="flex-shrink-0">
          <svg
            class="h-5 w-5 text-green-400"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
              clip-rule="evenodd"
            />
          </svg>
        </div>
        <div class="ml-3">
          <p class="text-sm leading-5 font-medium text-green-800">
            We emailed you a link access Picnic
          </p>
        </div>
      </div>
    </div>
    <div
      v-else-if="isStatusError"
      class="border-8 border-white  rounded-md bg-red-50 p-4"
    >
      <div class="flex">
        <div class="flex-shrink-0">
          <svg
            class="h-5 w-5 text-red-400"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
              clip-rule="evenodd"
            />
          </svg>
        </div>
        <div class="ml-3">
          <h3 class="text-sm leading-5 font-medium text-red-800">
            Login Failed
          </h3>
          <div class="mt-2 text-sm leading-5 text-red-700">
            <ul class="list-disc pl-5">
              <li>
                You may not be a user on this account
              </li>
              <li class="mt-1">
                You may not have access to this site
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <label
        for="email"
        class="block text-sm font-medium leading-5 text-gray-700"
        >Email Address</label
      >
      <div class="mt-2 rounded-md shadow-sm">
        <div class="relative  focus-within:z-10">
          <input
            id="email"
            ref="loginInput"
            class="form-input block w-full rounded-md pl-3 transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            placeholder="adam@picnic.team"
            v-model="$v.email.$model"
          />
        </div>
      </div>
      <div class="mt-6">
        <button
          @click="go"
          type="submit"
          class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white ps-bg-brand-brown-600 hover:ps-bg-brand-brown-400 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-white transition duration-150 ease-in-out"
        >
          <span class="absolute left-0 inset-y-0 flex items-center pl-3">
            <svg
              class="h-5 w-5 text-white  transition ease-in-out duration-150"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fill-rule="evenodd"
                d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                clip-rule="evenodd"
              />
            </svg>
          </span>
          Sign in
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from '@picnic-software/vuex'
import ButtonPrimary from '@/components/buttons/ButtonPrimary'
import BaseFormField from '@/components/forms/BaseFormField'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'

const STATUS_INIT = 'STATUS_INIT'
const STATUS_SUBMITTED = 'STATUS_SUBMITTED'
const STATUS_ERROR = 'STATUS_ERROR'
const STATUS_SUCCESS = 'STATUS_SUCCESS'
const STATUS_LOADING = 'STATUS_LOADING'

export default {
  name: 'LoginStrategyLocal',
  components: {
    BaseFormField,
    ButtonPrimary
  },
  mixins: [validationMixin],
  data() {
    return {
      email: 'kevin@picnic.team',
      status: STATUS_INIT
    }
  },

  computed: {
    isStatusSuccess() {
      return this.status === STATUS_SUCCESS
    },
    isStatusError() {
      return this.status === STATUS_ERROR
    },
    isStatusLoading() {
      return this.status === STATUS_LOADING
    },
    isFormClean() {
      return !this.$v.$anyError && this.$v.$dirty
    }
  },
  validations: {
    email: {
      required,
      email
    }
  },
  methods: {
    ...mapActions({
      login: 'auth/login'
    }),
    async go() {
      try {
        await this.login(this.email)
        this.status = STATUS_SUCCESS
      } catch (e) {
        this.status = STATUS_ERROR
      }
    }
  }
}
</script>
